//--------------- IMPORTAÇÕES ---------------//
import { useContext } from "react";
import { NumericFormat } from "react-number-format";
import { GastosContext } from "../context/GastosContext";
import { formatterDate } from "../../../shared/utils"
import { createCostService } from "../services";



//--------------- EXPORTAÇÃO DO COMPONENTE MAIN ---------------//
export default function TableCosts() {


    //--------------- CRIAÇÃO DE HOOKS ---------------//
    const { costs, setCosts } = useContext(GastosContext)
    const { isSaving, setIsSaving } = useContext(GastosContext);



    //--------------- FUNÇÃO HANDLE CHANGE ---------------//
    // Responsável por, quando o usuário alterar o valor de determinado Gasto, inserir a alteração da Lista de Gastos
    // Armazena no Estado "gastos" a nova lista de gastos alterada
    const handleChange = (index, valor) => {
        const newCosts = [...costs];
        newCosts[index].valor = valor;
        setCosts(newCosts);
    };



    //--------------- FUNÇÃO ASSÍNCRONA SALVAR GASTO ---------------//
    // Responsável por salvar o Gasto alterado via API
    const handleSaveCost = async (index) => {
        setIsSaving(true);
        const { grupo_id, valor } = costs[index];
        console.log(valor)
        await createCostService(grupo_id, valor)
        setIsSaving(false);
    };



    //--------------- RETORNO DO COMPONENTE MAIN ---------------//
    return (
        <>

            {/* DIV QUE CONTÊM A TABELA */}
            <div className="bg-surface-2 rounded-xl shadow border border-white/[0.08] overflow-x-auto">

                {/* TABELA */}
                <table className="w-full text-xs lg:text-sm table-fixed">

                    {/* CABEÇALHO DA TABELA */}
                    <thead>
                        <tr className="bg-surface-3">
                            <th className="p-3 w-[35%] sm:w-[25%] text-left">Grupo</th>
                            <th className="p-3 sm:w-[20%] text-left hidden sm:table-cell">Data</th>
                            <th className="p-3 w-[65%] sm:w-[40%] text-left">Valor</th>
                            <th className="p-3 sm:w-[15%] text-left hidden sm:table-cell">Ações</th>
                        </tr>
                    </thead>

                    {/* CORPO DA TABELA */}
                    <tbody>
                        {costs.map((g, i) => (
                            <>
                                <tr key={g.grupo_id} className="border-t border-white/[0.08]">
                                    <td className="p-3 w-[35%] sm:w-[25%] font-medium">{g.nome}</td>
                                    <td className="p-3 sm:table-cell hidden sm:w-[20%]">{formatterDate(g.data)}</td>
                                    <td className="p-3 w-[65%] sm:w-[15%]">
                                        <NumericFormat
                                            value={g.valor}
                                            thousandSeparator="."
                                            decimalSeparator=","
                                            prefix="R$ "
                                            decimalScale={2}
                                            fixedDecimalScale
                                            allowNegative={false}
                                            onValueChange={(values) => handleChange(i, values.floatValue)}
                                            customInput="input"
                                            className="bg-surface-1 border w-full border-white/[0.12] rounded px-3 py-1 text-sm"
                                        />
                                    </td>
                                    <td className="p-3 sm:w-[15%] sm:table-cell hidden">
                                        <div className="p-3">
                                            <button
                                                onClick={() => handleSaveCost(i)}
                                                disabled={isSaving}
                                                className="bg-brand-600 hover:bg-brand-700 px-4 py-1 rounded disabled:opacity-50"
                                            >
                                                {isSaving ? "Salvando..." : "Salvar"}
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="sm:hidden border-b border-white/[0.08]">
                                    <td colSpan={2} className="p-3">
                                        <div className="flex flex-row gap-2 items-center text-right">
                                            <p className="mr-auto truncate">Data: {formatterDate(g.data)}</p>
                                            <button
                                                onClick={() => handleSaveCost(i)}
                                                disabled={isSaving}
                                                className="bg-brand-600 hover:bg-brand-700 px-4 py-1 rounded disabled:opacity-50"
                                            >
                                                {isSaving ? "Salvando..." : "Salvar"}
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </>
                        ))}

                    </tbody>

                </table>

            </div>

        </>
    )
}